export default __webpack_public_path__ + "static/static-asset-data-sim-data-plan-1ab005c699389577c158e3718ee5e712.svg";